<template>
  <svg
    class="sidebar-logo-morph"
    :class="{ 'sidebar-logo-morph--collapsed': collapsed }"
    fill="none"
    height="36"
    :style="morphStyle"
    viewBox="0 0 89 36"
    width="89"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g class="sidebar-logo-morph__wordmark">
      <path
        d="M10.6174 7.15505H13.6377V12.9072C12.8622 13.4878 11.9643 13.9334 10.9439 14.2439C9.92348 14.5545 8.89626 14.7098 7.86226 14.7098C6.37927 14.7098 5.04597 14.3959 3.86228 13.768C2.67863 13.1401 1.75006 12.2692 1.07659 11.1552C0.403124 10.0412 0.0664062 8.7821 0.0664062 7.37784C0.0664062 5.97357 0.403124 4.71444 1.07659 3.60046C1.75006 2.48651 2.68544 1.61556 3.88269 0.987692C5.07997 0.35982 6.42691 0.0458984 7.92349 0.0458984C9.17519 0.0458984 10.3112 0.255189 11.3316 0.673771C12.352 1.09235 13.2092 1.69997 13.903 2.49662L11.7806 4.441C10.7602 3.37429 9.52891 2.84094 8.08677 2.84094C7.1752 2.84094 6.36568 3.02997 5.6582 3.40804C4.95073 3.78611 4.39969 4.31947 4.00515 5.00811C3.61061 5.69675 3.41333 6.48667 3.41333 7.37784C3.41333 8.25551 3.61061 9.03867 4.00515 9.72731C4.39969 10.4159 4.94732 10.9527 5.64798 11.3375C6.34867 11.7223 7.14797 11.9147 8.04595 11.9147C8.99831 11.9147 9.85544 11.7122 10.6174 11.3071V7.15505Z"
        fill="#091540"
      />
      <path
        d="M17.0114 0.279297H20.3218V11.7987H27.4943V14.4757H17.0114V0.279297Z"
        fill="#091540"
      />
      <path
        clip-rule="evenodd"
        d="M56.5246 7.09358C57.3419 7.35047 57.9824 7.77975 58.4454 8.3814C58.9087 8.98308 59.1403 9.72331 59.1403 10.6021C59.1403 11.846 58.6533 12.8026 57.679 13.4718C56.705 14.1411 55.2849 14.4757 53.4184 14.4757H46.0211V0.279297H53.0096C54.7535 0.279297 56.0919 0.610563 57.0253 1.27304C57.9584 1.93554 58.4249 2.83465 58.4249 3.97039C58.4249 4.65991 58.2581 5.27508 57.9243 5.8159C57.5905 6.35673 57.1239 6.78263 56.5246 7.09358ZM49.311 2.75354V6.09984H52.6012C53.4184 6.09984 54.0384 5.95787 54.4606 5.67397C54.883 5.39003 55.0942 4.97089 55.0942 4.41654C55.0942 3.86223 54.883 3.44647 54.4606 3.1693C54.0384 2.89212 53.4184 2.75354 52.6012 2.75354H49.311ZM55.1451 11.5756C54.7026 11.8596 54.0452 12.0015 53.1732 12.0015H49.311V8.49297H53.1732C54.9307 8.49297 55.8093 9.08109 55.8093 10.2574C55.8093 10.8523 55.588 11.2917 55.1451 11.5756Z"
        fill="#091540"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M64.7111 11.4336H71.3524L72.6194 14.4757H76.0932L69.6971 0.279297H66.4274L60.0518 14.4757H63.4441L64.7111 11.4336ZM68.0418 3.50391L70.31 8.93912H65.7736L68.0418 3.50391Z"
        fill="#091540"
        fill-rule="evenodd"
      />
      <path
        d="M77.8582 0.279297H81.1688V11.7987H88.3412V14.4757H77.8582V0.279297Z"
        fill="#091540"
      />
      <path
        d="M0.658813 21.4854H3.97294V33.0174H11.1535V35.6977H0.658813V21.4854Z"
        fill="#091540"
      />
      <path
        d="M25.0581 33.0583V35.6977H13.9701V21.4854H24.7921V24.1248H17.2638V27.2108H23.9124V29.7691H17.2638V33.0583H25.0581Z"
        fill="#091540"
      />
      <path
        clip-rule="evenodd"
        d="M34.578 21.4854H28.0726V35.6977H34.578C36.1329 35.6977 37.5071 35.4031 38.7003 34.8143C39.8938 34.2257 40.8209 33.3966 41.4824 32.3271C42.1439 31.2579 42.4748 30.0125 42.4748 28.5914C42.4748 27.1702 42.1439 25.9249 41.4824 24.8557C40.8209 23.7864 39.8938 22.9573 38.7003 22.3685C37.5071 21.7797 36.1329 21.4854 34.578 21.4854ZM37.8412 31.8094C36.9887 32.6014 35.8464 32.9971 34.4145 32.9971H31.3868V24.1856H34.4145C35.8464 24.1856 36.9887 24.5815 37.8412 25.3734C38.6935 26.1651 39.1197 27.2379 39.1197 28.5914C39.1197 29.9449 38.6935 31.0177 37.8412 31.8094Z"
        fill="#091540"
        fill-rule="evenodd"
      />
      <path
        d="M55.3714 28.3682H58.3953V34.1272C57.6189 34.7084 56.7201 35.1547 55.6984 35.4654C54.6768 35.7765 53.6486 35.932 52.6133 35.932C51.1286 35.932 49.7938 35.6177 48.6086 34.9889C47.4237 34.3603 46.4939 33.4884 45.8197 32.3733C45.1455 31.2579 44.8083 29.9972 44.8083 28.5914C44.8083 27.1855 45.1455 25.9249 45.8197 24.8097C46.4939 23.6944 47.4305 22.8225 48.629 22.1939C49.8279 21.5653 51.1763 21.251 52.6746 21.251C53.9276 21.251 55.0651 21.4605 56.0865 21.8796C57.1082 22.2987 57.9663 22.907 58.661 23.7046L56.5362 25.6512C55.5145 24.5833 54.2819 24.0493 52.8381 24.0493C51.9254 24.0493 51.115 24.2386 50.4067 24.6171C49.6984 24.9956 49.1466 25.5295 48.7517 26.2189C48.3565 26.9083 48.1592 27.6991 48.1592 28.5914C48.1592 29.4701 48.3565 30.2542 48.7517 30.9436C49.1466 31.633 49.6949 32.1704 50.3963 32.5558C51.0978 32.9409 51.8982 33.1335 52.7972 33.1335C53.7505 33.1335 54.6086 32.931 55.3714 32.5252V28.3682Z"
        fill="#091540"
      />
      <path
        d="M72.643 33.0583V35.6977H61.5551V21.4854H72.377V24.1248H64.8488V27.2108H71.4972V29.7691H64.8488V33.0583H72.643Z"
        fill="#091540"
      />
      <path
        clip-rule="evenodd"
        d="M82.0198 31.7385L84.7815 35.6977H88.3412L85.1292 31.1294C86.0704 30.7234 86.7967 30.1378 87.308 29.3731C87.8195 28.6084 88.0752 27.6983 88.0752 26.6422C88.0752 25.5865 87.8228 24.6729 87.3183 23.9014C86.8136 23.1299 86.0943 22.5343 85.16 22.1147C84.2258 21.6951 83.1244 21.4854 81.8563 21.4854H75.6575V35.6977H78.9716V31.7385H81.8563H82.0198ZM83.9429 24.8049C84.461 25.2311 84.7202 25.8438 84.7202 26.6422C84.7202 27.4275 84.461 28.0363 83.9429 28.4697C83.4245 28.9027 82.6676 29.1194 81.672 29.1194H78.9716V24.1653H81.672C82.6676 24.1653 83.4245 24.3785 83.9429 24.8049Z"
        fill="#091540"
        fill-rule="evenodd"
      />
    </g>
    <!-- The "O" of the wordmark is the same shape as the short logo, so it is
         the part that survives the collapse and grows into the short mark. -->
    <g class="sidebar-logo-morph__mark">
      <path
        clip-rule="evenodd"
        d="M32.7204 10.1685C33.5385 11.1554 34.7785 11.7849 36.1669 11.7849C38.6303 11.7849 40.6275 9.80286 40.6275 7.35793C40.6275 6.80979 40.5271 6.2849 40.3437 5.80044L42.9404 4.3125C43.3649 5.24089 43.6013 6.27202 43.6013 7.35793C43.6013 11.4328 40.2729 14.7362 36.1669 14.7362C33.6769 14.7362 31.473 13.5214 30.1237 11.6563L32.7204 10.1685Z"
        fill="#5A78EA"
        fill-rule="evenodd"
      />
      <path
        d="M36.9365 0.0195312V2.99743C37.981 3.17771 38.9005 3.71844 39.5608 4.48575L42.1622 2.99508C40.9521 1.36009 39.0791 0.238259 36.9365 0.0195312Z"
        fill="#FF2A00"
      />
      <path
        d="M35.3973 0.0195312C31.653 0.401746 28.7325 3.54175 28.7325 7.35873C28.7325 8.41603 28.9565 9.42139 29.3602 10.3306L31.962 8.83976C31.7964 8.3767 31.7063 7.87815 31.7063 7.35873C31.7063 5.17428 33.3003 3.35936 35.3973 2.99743V0.0195312Z"
        fill="#091540"
      />
    </g>
  </svg>
</template>

<script>
// Geometry of the bundled default-logo.svg, in viewBox units
const VIEWBOX_WIDTH = 89
const MARK_CENTER_X = 36.167
const MARK_CENTER_Y = 7.378
const MARK_HEIGHT = 14.717

// The bundled default logo (default-logo.svg, 89x36) drawn as one inline SVG
// whose mark can move independently of the wordmark: on collapse the wordmark
// folds into the "O" while the "O" grows into the short logo, and back.
export default {
  name: 'SidebarLogoMorph',
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
    // Rendered width of the full logo, px
    width: {
      type: Number,
      default: 110,
    },
    // Rendered size of the short mark the logo collapses into, px
    markSize: {
      type: Number,
      default: 36,
    },
    // Where the short mark's centre sits, px from the svg's top-left corner
    collapsedCenter: {
      type: Object,
      default: () => ({ x: 12, y: 22 }),
    },
  },
  computed: {
    morphStyle() {
      const unit = this.width / VIEWBOX_WIDTH
      const dx = this.collapsedCenter.x / unit - MARK_CENTER_X
      const dy = this.collapsedCenter.y / unit - MARK_CENTER_Y
      const scale = this.markSize / (MARK_HEIGHT * unit)

      return {
        width: `${this.width}px`,
        height: 'auto',
        '--morph-origin': `${MARK_CENTER_X}px ${MARK_CENTER_Y}px`,
        '--morph-shift': `translate(${dx}px, ${dy}px)`,
        '--morph-scale': scale,
      }
    },
  },
}
</script>

<style scoped>
.sidebar-logo-morph {
  display: block;
  overflow: visible;
}

.sidebar-logo-morph__wordmark,
.sidebar-logo-morph__mark {
  transform-box: view-box;
  transform-origin: var(--morph-origin);
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.sidebar-logo-morph--collapsed .sidebar-logo-morph__mark {
  transform: var(--morph-shift) scale(var(--morph-scale));
}

/* The wordmark shrinks toward the "O" while it fades, so it reads as folding
   into the mark rather than just disappearing */
.sidebar-logo-morph--collapsed .sidebar-logo-morph__wordmark {
  opacity: 0;
  transform: var(--morph-shift) scale(0.4);
  transition: transform 0.2s ease, opacity 0.12s ease-in;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-logo-morph__wordmark,
  .sidebar-logo-morph__mark,
  .sidebar-logo-morph--collapsed .sidebar-logo-morph__wordmark {
    transition: none;
  }
}
</style>
